import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../ts/Glob';
import { config } from '../ts/config';
import { IAuthState, IOpenIDProvider } from '../../src/ts/stores/AuthStore';

const TITLE_SETTING_FIELD = 'GUI/Title';

interface ISignInPopupState extends IAuthState {
    recoverPassword: boolean;
    showPassword: boolean;
    showResetPassword_1: boolean;
    showResetPassword_2: boolean;
    approveNewDevice: boolean;
}

export class SignInPopup extends React.Component<
    {
        glob: IGlob;
    },
    ISignInPopupState
> {
    references: {
        resetPassword?: HTMLInputElement;
        resetPasswordRepeat?: HTMLInputElement;
        name?: HTMLInputElement;
        password?: HTMLInputElement;
        rememberMe?: HTMLInputElement;
        recoverEmail?: HTMLInputElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = _.extend({}, this.getState(), {
            recoverPassword: false,
            showPassword: false,
            showResetPassword_1: false,
            showResetPassword_2: false,
            approveNewDevice: false
        });
    }

    getState() {
        return this.props.glob.AuthStore.getState();
    }

    componentDidMount() {
        this.props.glob.AuthStore.addChangeListener(this._onChange);
        this.props.glob.AppActions.passwordGetRequirements();
        //this.props.glob.AuthStore.getOpenIDProviders();
    }

    componentWillUnmount() {
        this.props.glob.AuthStore.removeChangeListener(this._onChange);
    }

    _onChange = () => {
        this.setState(this.getState());
    };

    _getStyle = () => {
        return {
            display: 'block'
        };
    };

    _getStyleDialog = () => {
        return {
            maxWidth: $(window).width()
        };
    };

    processSignIn = (e) => {
        if (this.state.loading !== true) {
            this.props.glob.AppActions.signIn(
                this.references.name.value.trim(),
                this.references.password.value,
                this.references.rememberMe.checked
            );
        }

        e.stopPropagation();
        e.preventDefault();
        //return false; Warning 'return false is deprecated'
    };

    authenticateWithOpenID = (providerName) => {
        this.props.glob.AppActions.signInWithOpenID(providerName);
    };

    processRecover = (e) => {
        if (this.state.loading !== true) {
            this.props.glob.AppActions.recoverPasswordRequest(this.references.recoverEmail.value);
        }

        e.stopPropagation();
        e.preventDefault();
        //return false; Warning 'return false is deprecated'
    };

    processResetPassword = (e) => {
        if (this.state.loading !== true) {
            this.props.glob.AppActions.passwordResetRequest(
                this.state.passwordResetEmail,
                this.state.passwordResetToken,
                this.references.resetPassword.value,
                this.references.resetPasswordRepeat.value
            );
        }

        e.stopPropagation();
        e.preventDefault();
        //return false; Warning 'return false is deprecated'
    };

    recoverPasswordClick = (e) => {
        this.setState({
            recoverPassword: true
        });

        e.stopPropagation();
        e.preventDefault();
        //return false; Warning 'return false is deprecated'
    };

    displayInitial = (e) => {
        this.setState({
            recoverPassword: false
        });

        this.props.glob.AppActions.passwordResetEnd();

        e.stopPropagation();
        e.preventDefault();
        //return false; Warning 'return false is deprecated'
    };

    getPasswordGetRequirements = () => {
        let buttonTitle;

        if (this.state.loading) {
            buttonTitle = 'Loading';
        } else {
            buttonTitle = 'Send mail to recover Password';
        }

        let labelStyle: React.CSSProperties = {};
        let fieldStyle: React.CSSProperties = {};
        let buttonStyle: React.CSSProperties = {};
        let linkStyle: React.CSSProperties = {};
        let leftLinkStyle: React.CSSProperties = {};
        let labelClass: string = 'col-sm-3 col-form-label text-right';
        let fieldClass: string = 'col-sm-8';
        let fieldOffsetClass: string = 'col-sm-8 offset-3';

        if (this.props.glob.customSignInForm != null) {
            const styles = this.props.glob.customSignInForm.getSignInFormElementStyles();
            labelStyle = styles.labelStyle;
            fieldStyle = styles.fieldStyle;
            buttonStyle = styles.buttonStyle;
            linkStyle = styles.linkStyle;
            leftLinkStyle = styles.leftLinkStyle;

            const classes = this.props.glob.customSignInForm.getSignInFormElementClasses();
            labelClass = classes.labelClass;
            fieldClass = classes.fieldClass;
            fieldOffsetClass = classes.fieldOffsetClass;
        }

        return (
            <form id="recover-password-form" role="form">
                <div className="form-group row">
                    <div
                        className={fieldOffsetClass}
                        style={_.extend({}, linkStyle, {
                            fontSize: 'large'
                        })}
                    >
                        Check your email for a reset link
                    </div>
                </div>
                <div
                    className={fieldOffsetClass}
                    style={_.extend({}, linkStyle, {
                        lineHeight: 1.5
                    })}
                >
                    If you don't find the email in your inbox, check your spam folder.
                </div>
                <div
                    className={fieldOffsetClass}
                    style={_.extend({}, leftLinkStyle, {
                        lineHeight: 1.5
                    })}
                >
                    <ul>
                        <li>Only registered users can apply for a new password.</li>
                        <li>
                            Please contact{' '}
                            <a href={config.CONTACT_VENDOR_URL} target="_blank">
                                {config.CONTACT_VENDOR}
                            </a>{' '}
                            if you need further assistance.
                        </li>
                    </ul>
                </div>
                <div className="form-group row">
                    <label htmlFor="recover-form-email" className={labelClass} style={labelStyle}>
                        {'Email'}
                    </label>
                </div>

                <div className={fieldOffsetClass} style={linkStyle}>
                    <a
                        href="#"
                        onClick={(e) => {
                            this.props.glob.AppActions.recoverPasswordRequestReset();
                            this.displayInitial(e);
                        }}
                    >
                        {'Close'}
                    </a>
                </div>
            </form>
        );
    };

    getRecoverPassword = () => {
        let buttonTitle;

        if (this.state.loading) {
            buttonTitle = 'Loading';
        } else {
            buttonTitle = 'Send mail to recover Password';
        }

        let labelStyle: React.CSSProperties = {};
        let fieldStyle: React.CSSProperties = {};
        let buttonStyle: React.CSSProperties = {};
        let linkStyle: React.CSSProperties = {};
        let labelClass: string = 'col-sm-3 col-form-label text-right';
        let fieldClass: string = 'col-sm-8';
        let fieldOffsetClass: string = 'col-sm-8 offset-3';

        if (this.props.glob.customSignInForm != null) {
            const styles = this.props.glob.customSignInForm.getSignInFormElementStyles();
            labelStyle = styles.labelStyle;
            fieldStyle = styles.fieldStyle;
            buttonStyle = styles.buttonStyle;
            linkStyle = styles.linkStyle;

            const classes = this.props.glob.customSignInForm.getSignInFormElementClasses();
            labelClass = classes.labelClass;
            fieldClass = classes.fieldClass;
            fieldOffsetClass = classes.fieldOffsetClass;
        }

        return (
            <form id="recover-password-form" role="form" onSubmit={this.processRecover}>
                <div className="form-group row">
                    <div
                        className={fieldOffsetClass}
                        style={_.extend({}, linkStyle, {
                            fontSize: 'large'
                        })}
                    >
                        Please set me up with a new password
                    </div>
                </div>
                <div
                    className={fieldOffsetClass}
                    style={_.extend({}, linkStyle, {
                        lineHeight: 1.5
                    })}
                >
                    To reset your password, enter your email address and we'll send you and email with instructions.
                </div>
                <div className="form-group row">
                    <label htmlFor="recover-form-email" className={labelClass} style={labelStyle}>
                        {'Email'}
                    </label>

                    <div className={fieldClass}>
                        <input
                            key="recoverEmail"
                            disabled={this.state.loading === true}
                            ref={(input) => {
                                this.references.recoverEmail = input;
                            }}
                            type="text"
                            tabIndex={1}
                            className="autofillOff form-control"
                            id="recover-form-email"
                            placeholder="Email"
                            style={fieldStyle}
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <div className={fieldOffsetClass}>
                        <button
                            disabled={this.state.loading === true}
                            type="submit"
                            tabIndex={2}
                            className="btn btn-primary"
                            style={buttonStyle}
                        >
                            {buttonTitle}
                        </button>
                    </div>
                </div>
                <div className={fieldOffsetClass} style={linkStyle}>
                    <a href="#" onClick={this.displayInitial}>
                        {'Cancel'}
                    </a>
                </div>
            </form>
        );
    };

    getPasswordReset = (isNew, title) => {
        let buttonTitle;
        let pwdPlaceholder;
        let back;

        if (this.state.loading) {
            buttonTitle = 'Loading';
        } else if (isNew === true) {
            buttonTitle = 'Create Password';
            pwdPlaceholder = 'Password';
        } else {
            pwdPlaceholder = 'New Password';
            buttonTitle = 'Reset Password';
        }

        let labelStyle: React.CSSProperties = {};
        let fieldStyle: React.CSSProperties = {};
        let buttonStyle: React.CSSProperties = {};
        let labelClass: string = 'col-sm-3 col-form-label text-right';
        let fieldClass: string = 'col-sm-8';
        let fieldOffsetClass: string = 'col-sm-8 offset-3';

        if (this.props.glob.customSignInForm != null) {
            const styles = this.props.glob.customSignInForm.getSignInFormElementStyles();
            labelStyle = styles.labelStyle;
            fieldStyle = styles.fieldStyle;
            buttonStyle = styles.buttonStyle;

            const classes = this.props.glob.customSignInForm.getSignInFormElementClasses();
            labelClass = classes.labelClass;
            fieldClass = classes.fieldClass;
            fieldOffsetClass = classes.fieldOffsetClass;
        }

        if (isNew !== true) {
            back = (
                <div className="form-group row">
                    <div className={fieldOffsetClass}>
                        <a href="#" onClick={this.displayInitial}>
                            {'Goto Login Dialog'}
                        </a>
                    </div>
                </div>
            );
        }

        const eyeClassName = 'col-sm-1 d-flex flex-nowrap justify-content-center align-items-center form-control ';

        let eyeClassName_1 = this.state.showResetPassword_1
            ? eyeClassName + 'autofillOff glyphicon glyphicon-eye-open'
            : eyeClassName + 'autofillOff glyphicon glyphicon-eye-close';
        let eyeClassName_2 = this.state.showResetPassword_2
            ? eyeClassName + 'autofillOff glyphicon glyphicon-eye-open'
            : eyeClassName + 'autofillOff glyphicon glyphicon-eye-close';
        let eyefieldStyle = fieldStyle;
        eyefieldStyle.cursor = 'pointer';

        let passwordLength;
        let passwordMixedLetter;
        let passwordLettresAndDigits;
        let header;

        if (this.state.passwordMinLength) {
            passwordLength = (
                <div className="align-self-center">
                    <label className="mb-0" htmlFor="reset-form-password">
                        {'Your new password must be at least ' + this.state.passwordMinLength + ' characters long.'}
                    </label>
                </div>
            );

            if (this.state.passwordMustHaveMixedLetterCase) {
                passwordMixedLetter = (
                    <div className="align-self-center">
                        <label className="mb-0" htmlFor="reset-form-password">
                            {'Password must have mixed letter case.'}
                        </label>
                    </div>
                );
            }

            if (this.state.passwordMustContainLettresAndDigits) {
                passwordLettresAndDigits = (
                    <div className="align-self-center">
                        <label className="mb-0" htmlFor="reset-form-password">
                            {'Password must have numbers and letters.'}
                        </label>
                    </div>
                );
            }

            header = (
                <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                    {this.props.glob.customSignInForm ? (
                        <div className="align-self-center">
                            <label htmlFor="reset-form-password" style={{ fontSize: 'larger' }}>
                                {title}
                            </label>
                        </div>
                    ) : null}
                    {passwordLength}
                    {passwordMixedLetter}
                    {passwordLettresAndDigits}
                    <div className="mb-3"></div>
                </div>
            );
        }

        return (
            <form id="password-reset-form" role="form" onSubmit={this.processResetPassword}>
                {header}
                {back}

                <div className="form-group row">
                    <label htmlFor="reset-form-password" className={labelClass} style={labelStyle}>
                        {'Password'}
                    </label>

                    <div className={fieldClass + ' d-flex flex-nowrap'}>
                        <input
                            key="resetPassword"
                            disabled={this.state.loading === true}
                            ref={(input) => {
                                this.references.resetPassword = input;
                            }}
                            type={this.state.showResetPassword_1 ? 'text' : 'password'}
                            tabIndex={1}
                            className="form-control"
                            id="reset-form-password"
                            name="reset-form-password"
                            autoComplete="new-password"
                            placeholder={pwdPlaceholder}
                            style={_.extend({}, fieldStyle, {
                                borderTop: '1px solid #CCCCCC',
                                borderRight: '0',
                                borderBottom: '1px solid #CCCCCC',
                                borderLeft: '1px solid #CCCCCC',
                                height: fieldStyle.height,
                                borderBottomRightRadius: 0,
                                borderTopRightRadius: 0
                            })}
                        />
                        <button
                            type="button"
                            className={eyeClassName_1}
                            tabIndex={0}
                            style={{
                                cursor: 'pointer',
                                borderTop: '1px solid #CCCCCC',
                                borderRight: '1px solid #CCCCCC',
                                borderBottom: '1px solid #CCCCCC',
                                borderLeft: '0',
                                height: fieldStyle.height,
                                width: fieldStyle.height,
                                top: '0',
                                borderBottomLeftRadius: 0,
                                borderTopLeftRadius: 0
                            }}
                            onClick={this.handleShowHideResetPassword_1}
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <label htmlFor="reset-form-password-repeat" className={labelClass} style={labelStyle}>
                        {'Repeat Password'}
                    </label>

                    <div className={fieldClass + ' d-flex flex-nowrap'}>
                        <input
                            key="resetPasswordRepeat"
                            disabled={this.state.loading === true}
                            ref={(input) => {
                                this.references.resetPasswordRepeat = input;
                            }}
                            type={this.state.showResetPassword_2 ? 'text' : 'password'}
                            tabIndex={2}
                            className="form-control"
                            id="reset-form-password-repeat"
                            name="reset-form-password-repeat"
                            autoComplete="new-password"
                            placeholder="Repeat Password"
                            style={_.extend({}, fieldStyle, {
                                borderTop: '1px solid #CCCCCC',
                                borderRight: '0',
                                borderBottom: '1px solid #CCCCCC',
                                borderLeft: '1px solid #CCCCCC',
                                height: fieldStyle.height,
                                borderBottomRightRadius: 0,
                                borderTopRightRadius: 0
                            })}
                        />
                        <button
                            type="button"
                            className={eyeClassName_2}
                            tabIndex={0}
                            style={{
                                cursor: 'pointer',
                                borderTop: '1px solid #CCCCCC',
                                borderRight: '1px solid #CCCCCC',
                                borderBottom: '1px solid #CCCCCC',
                                borderLeft: '0',
                                height: fieldStyle.height,
                                width: fieldStyle.height,
                                top: '0',
                                borderBottomLeftRadius: 0,
                                borderTopLeftRadius: 0
                            }}
                            onClick={this.handleShowHideResetPassword_2}
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <div className={fieldOffsetClass}>
                        <button
                            disabled={this.state.loading === true}
                            type="submit"
                            tabIndex={3}
                            className="btn btn-primary"
                            style={buttonStyle}
                        >
                            {buttonTitle}
                        </button>
                    </div>
                </div>
            </form>
        );
    };

    getApproveNewDevice = () => {
        //let labelStyle: React.CSSProperties = {};
        //let fieldStyle: React.CSSProperties = {};
        let buttonStyle: React.CSSProperties = {};
        //let labelClass: string = 'col-sm-3 col-form-label text-right';
        //let fieldClass: string = 'col-sm-8';
        let fieldOffsetClass: string = 'col-sm-8 offset-3';

        if (this.props.glob.customSignInForm != null) {
            const styles = this.props.glob.customSignInForm.getSignInFormElementStyles();
            //labelStyle = styles.labelStyle;
            //fieldStyle = styles.fieldStyle;
            buttonStyle = styles.buttonStyle;

            const classes = this.props.glob.customSignInForm.getSignInFormElementClasses();

            //labelClass = classes.labelClass;
            //fieldClass = classes.fieldClass;
            fieldOffsetClass = classes.fieldOffsetClass;
        }

        return (
            <form id="approve-device-form" role="form">
                <div className="form-group row ">
                    <div className={fieldOffsetClass + ' mt-5'}>
                        <button
                            type="button"
                            disabled={this.state.loading === true}
                            onClick={this.handleApproveNewDevice}
                            tabIndex={3}
                            className="btn btn-primary"
                            style={buttonStyle}
                        >
                            {'Approve New Device'}
                        </button>
                    </div>
                </div>
            </form>
        );
    };

    handleShowHidePassword = () => {
        this.setState({
            showPassword: !this.state.showPassword
        });
    };

    handleShowHideResetPassword_1 = () => {
        this.setState({
            showResetPassword_1: !this.state.showResetPassword_1
        });
    };

    handleShowHideResetPassword_2 = () => {
        this.setState({
            showResetPassword_2: !this.state.showResetPassword_2
        });
    };

    handleApproveNewDevice = () => {
        this.props.glob.AppActions.approveNewDevice(this.state.approveNewDeviceToken);
    };

    getSignIn = () => {
        let buttonTitle;

        if (this.state.loading) {
            buttonTitle = 'Loading';
        } else {
            buttonTitle = 'Log In';
        }

        let labelStyle: React.CSSProperties = {};
        let fieldStyle: React.CSSProperties = {};
        let buttonStyle: React.CSSProperties = {};
        let linkStyle: React.CSSProperties = {};
        let labelClass: string = 'col-sm-3 col-form-label text-right';
        let fieldClass: string = 'col-sm-8';
        let fieldOffsetClass: string = 'col-sm-8 offset-3';

        if (this.props.glob.customSignInForm != null) {
            const styles = this.props.glob.customSignInForm.getSignInFormElementStyles();
            labelStyle = styles.labelStyle;
            fieldStyle = styles.fieldStyle;
            buttonStyle = styles.buttonStyle;
            linkStyle = styles.linkStyle;

            const classes = this.props.glob.customSignInForm.getSignInFormElementClasses();
            labelClass = classes.labelClass;
            fieldClass = classes.fieldClass;
            fieldOffsetClass = classes.fieldOffsetClass;
        }

        let eyeClassName = 'col-sm-1 d-flex flex-nowrap justify-content-center align-items-center form-control ';
        eyeClassName = this.state.showPassword
            ? eyeClassName + 'autofillOff glyphicon glyphicon-eye-open'
            : eyeClassName + 'autofillOff glyphicon glyphicon-eye-close';

        let eyefieldStyle = fieldStyle;
        eyefieldStyle.cursor = 'pointer';

        const placeholder = 'Username or email address';

        return (
            <form id="sign-in-form" role="form" onSubmit={this.processSignIn}>
                {this.state.openIDProviders != null &&
                this.state.openIDProviders.options.useLocalSignOn === false ? null : (
                    <div>
                        <div className="form-group row">
                            <label htmlFor="sign-in-form-username" className={labelClass} style={labelStyle}>
                                {'User ID'}
                            </label>

                            <div className={fieldClass}>
                                <input
                                    key="name"
                                    disabled={this.state.loading === true}
                                    ref={(input) => {
                                        this.references.name = input;
                                    }}
                                    type="text"
                                    tabIndex={1}
                                    autoComplete="on"
                                    className="autofillOff form-control"
                                    id="sign-in-form-username"
                                    placeholder={placeholder}
                                    style={fieldStyle}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="sign-in-form-password" className={labelClass} style={labelStyle}>
                                {'Password'}
                            </label>

                            <div className={fieldClass + ' d-flex flex-nowrap '}>
                                <input
                                    key="password"
                                    disabled={this.state.loading === true}
                                    ref={(input) => {
                                        this.references.password = input;
                                    }}
                                    type={this.state.showPassword ? 'input' : 'password'}
                                    tabIndex={2}
                                    className="autofillOff form-control"
                                    autoComplete="on"
                                    id="sign-in-form-password"
                                    placeholder="Password"
                                    style={_.extend({}, fieldStyle, {
                                        borderTop: '1px solid #CCCCCC',
                                        borderRight: '0',
                                        borderBottom: '1px solid #CCCCCC',
                                        borderLeft: '1px solid #CCCCCC',
                                        height: fieldStyle.height,
                                        borderBottomRightRadius: 0,
                                        borderTopRightRadius: 0
                                    })}
                                />
                                <button
                                    type="button"
                                    className={eyeClassName}
                                    tabIndex={0}
                                    style={{
                                        cursor: 'pointer',
                                        borderTop: '1px solid #CCCCCC',
                                        borderRight: '1px solid #CCCCCC',
                                        borderBottom: '1px solid #CCCCCC',
                                        borderLeft: '0',
                                        height: fieldStyle.height,
                                        width: fieldStyle.height,
                                        top: '0',
                                        borderBottomLeftRadius: 0,
                                        borderTopLeftRadius: 0
                                    }}
                                    onClick={this.handleShowHidePassword}
                                ></button>
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className={fieldOffsetClass}>
                                <div className="form-check">
                                    <input
                                        key="rememberMe"
                                        className="form-check-input"
                                        disabled={this.state.loading === true}
                                        ref={(input) => {
                                            this.references.rememberMe = input;
                                        }}
                                        type="checkbox"
                                        tabIndex={3}
                                        id="sign-in-form-remember-me"
                                        defaultChecked={true}
                                    />
                                    <label
                                        className="form-check-label font-weight-normal"
                                        htmlFor="sign-in-form-remember-me"
                                        style={{ marginTop: '0.25rem' }}
                                    >
                                        {'Remember me'}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className={fieldOffsetClass}>
                                <button
                                    disabled={this.state.loading === true}
                                    type="submit"
                                    tabIndex={4}
                                    className="btn btn-primary"
                                    style={buttonStyle}
                                >
                                    {buttonTitle}
                                </button>
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className={fieldOffsetClass} style={linkStyle}>
                                <a href="#" onClick={this.recoverPasswordClick}>
                                    {'Forgot Password?'}
                                </a>
                            </div>
                        </div>
                    </div>
                )}
                {this.renderOpenIDProviders(buttonStyle)}
            </form>
        );
    };

    getContent = () => {
        if (this.state.checkEmail) {
            return {
                title: 'Check Your Email',
                content: this.getPasswordGetRequirements()
            };
        }

        if (this.state.approveNewDevice) {
            return {
                title: 'Approve New Device',
                content: this.getApproveNewDevice()
            };
        }

        if (this.state.recoverPassword) {
            return {
                title: 'Recover Password',
                content: this.getRecoverPassword()
            };
        }

        if (this.state.passwordReset) {
            const title = 'Reset your Password';

            return {
                title: title,
                content: this.getPasswordReset(false, title)
            };
        }

        if (this.state.newUser) {
            const title = 'Create a new Password';

            return {
                title: title,
                content: this.getPasswordReset(true, title)
            };
        }

        return {
            content: this.getSignIn()
        };
    };

    private renderOpenIDProviders = (style: React.CSSProperties): React.JSX.Element => {
        let providerList: React.JSX.Element;
        if (
            this.state.openIDProviders != null &&
            this.state.openIDProviders.providers != null &&
            this.state.openIDProviders.options.authSendFrom === 'frontend'
        ) {
            providerList = (
                <div>
                    {_.map(this.state.openIDProviders.providers, (provider: IOpenIDProvider) => {
                        return (
                            <button
                                key={'openID_' + provider.name}
                                className="btn btn-secondary mb-1"
                                style={style}
                                onClick={(e) => {
                                    this.authenticateWithOpenID(provider.name);
                                    e.stopPropagation();
                                    e.preventDefault();
                                }}
                            >
                                {provider.icon != null ? (
                                    <img src={provider.icon} style={{ height: '1.5rem' }} className="mr-2" />
                                ) : null}
                                <span>{provider.description}</span>
                            </button>
                        );
                    })}
                </div>
            );
        }
        return providerList;
    };

    render() {
        const obj = this.getContent();
        const {
            app: { settings }
        } = this.props.glob.SettingsStore.getState();

        let title = obj.title || settings[TITLE_SETTING_FIELD] || config.TITLE_PREFIX || 'PDC Dashboard';

        if (title === '<% GUI/Title %>') {
            title = 'PDC Dashboard';
        }
        if (
            !(
                this.state.newUser === true ||
                this.state.passwordReset === true ||
                this.state.recoverPassword === true ||
                this.state.approveNewDevice === true
            )
        ) {
            title = 'Login to ' + title;
        }

        const errors = (
            <ul className="errors-list list-unstyled" style={{ color: 'red' }}>
                {_.map(this.state.errors, function (error, i) {
                    return <li key={i}> {error}</li>;
                })}
            </ul>
        );

        let hideContactPDC = false;
        if (this.state.recoverPassword === true || this.state.checkEmail) {
            hideContactPDC = true;
        }

        if (this.props.glob.customSignInForm != null) {
            return this.props.glob.customSignInForm.getSignInFormContent(
                config.LAYOUT_TYPE,
                title,
                errors,
                obj.content,
                hideContactPDC
            );
        } else {
            return (
                <div className="popup-sign-in">
                    <div className="modal fade show" style={this._getStyle()} role="dialog">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">{title}</h4>
                                </div>

                                <div className="modal-body">
                                    {errors}
                                    {obj.content}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </div>
            );
        }
    }
}
